module.exports = __webpack_public_path__ + "assets/img/NPC021.4dceab54.png";